import { gql } from "@at/sauron-platform-graphql";

export const leasingPDPImagesQuery = gql`
  query LeasingPDPImagesQuery(
    $generationId: String!
    $paint: String
    $trim: String
  ) {
    vehicle {
      images(generationId: $generationId, paint: $paint, trim: $trim) {
        url
        templated
      }
    }
  }
`;
